import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthLayoutRoutes } from './auth-layout.routing';
import { LoginComponent } from 'src/app/pages/commons/login/login.component';
import { RegisterComponent } from 'src/app/pages/commons/register/register.component';
import { ResetPasswordComponent } from 'src/app/pages/commons/reset-password/reset-password.component';
import { ConfirmationComponent } from 'src/app/pages/commons/confirmation/confirmation.component';
import { MapComponent } from 'src/app/pages/artist/map/map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ConnectWithComponent } from 'src/app/pages/commons/connect-with/connect-with.component';
import { BookingFormComponent } from 'src/app/pages/artist/booking-form/booking-form.component';
import { PasscultureComponent } from 'src/app/pages/commons/passculture/passculture.component';
import { OldStudioComponent } from 'src/app/pages/commons/old-studio/old-studio.component';
import { SocialLoginModule, SocialAuthServiceConfig, FacebookLoginProvider } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { environment } from 'src/environments/environment';
import { PaymentHelpComponent } from 'src/app/pages/commons/payment-help/payment-help.component';
import { MentionsLegalesComponent } from 'src/app/pages/commons/mentions-legales/mentions-legales.component';
import { PolitiqueConfidentialiteComponent } from 'src/app/pages/commons/politique-confidentialite/politique-confidentialite.component';
import { PolitiqueCookiesComponent } from 'src/app/pages/commons/politique-cookies/politique-cookies.component';
import { CguvCompanyComponent } from 'src/app/pages/commons/cguv-company/cguv-company.component';
import { CguvUserComponent } from 'src/app/pages/commons/cguv-user/cguv-user.component';
import { BookingFormTestComponent } from 'src/app/pages/artist/booking-form-test/booking-form-test.component';
import { CharteStudiomapComponent } from 'src/app/pages/commons/charte-studiomap/charte-studiomap.component';
import { NgbDatepickerI18n, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CustomDatepickerI18n, I18n } from 'src/app/services/translation/I18n.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AuthLayoutRoutes),
    FormsModule,
    GoogleMapsModule,
    ReactiveFormsModule,
    SocialLoginModule,
    NgbModule
  ],
  declarations: [
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    ConfirmationComponent,
    MapComponent,
    ConnectWithComponent,
    BookingFormComponent,
    PasscultureComponent,
    OldStudioComponent,
    PaymentHelpComponent,

    MentionsLegalesComponent,
    PolitiqueConfidentialiteComponent,
    PolitiqueCookiesComponent,
    CguvCompanyComponent,
    CguvUserComponent,
    CharteStudiomapComponent,
    BookingFormTestComponent
  ],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleProvider, {
              scope: 'profile email'
            }),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookProvider, {
              scope: 'public_profile email',
              return_scopes: true,
              enable_profile_selector: true
            })
          }
        ],
      } as SocialAuthServiceConfig,
    }
  ]
})
export class AuthLayoutModule { }
